/** "L.L.C." and "LLC", "Inc." and "Inc" are the same designator. */
function normalizeDesignatorWords(value: string): string {
  return value.toLowerCase().replace(/[.,]/g, "").trim().replace(/\s+/g, " ");
}

/**
 * Does the stored name already END with the designator as whole words? A
 * suffix inside a word ("Basinc" / "Inc") does not count. Mirrors
 * `businessNameEndsWithDesignator` in ProductData's `lib/company-name.ts`;
 * the console owns a copy because it cannot import from the Worker.
 */
function endsWithDesignator(name: string, designator: string): boolean {
  const normalizedName = normalizeDesignatorWords(name);
  const normalizedDesignator = normalizeDesignatorWords(designator);
  if (!normalizedName || !normalizedDesignator) return false;
  return (
    normalizedName === normalizedDesignator ||
    normalizedName.endsWith(` ${normalizedDesignator}`)
  );
}

/** Company names render business_name + designator, always — and once. */
export function companyDisplayName(row: {
  company_name_with_designator?: string | null;
  business_name?: string | null;
  designator?: string | null;
  company_id?: string | null;
}): string {
  if (row.company_name_with_designator) return row.company_name_with_designator;
  const businessName = (row.business_name ?? "").trim();
  const designator = (row.designator ?? "").trim();
  const name =
    businessName && designator && !endsWithDesignator(businessName, designator)
      ? `${businessName} ${designator}`
      : businessName || designator;
  return name || row.company_id || "No company";
}
